import { Navigate, useLocation, useParams } from "react-router-dom";

import useUserStore from "@/stores/useUserStore";
import AppOrders from "@/pages/Planning/OrderApplication/List/OrderApplication";

const LEGACY_OPTION_TO_NEW_PATH = {
	historial_compra: "/historiales/compra",
	historial_salida: "/historiales/salida",
	productos_en_uso: "/historiales/en_uso",
	historial_entrada: "/historiales/usos",
	otros_movimientos: "/historiales/otros_movimientos",
};
const OA_REDIRECT_USER_ID = 18;
const OA_REDIRECT_CUSTOMER_IDS = [23];

export const HistoryOrRedirect = () => {
	const { option } = useParams();

	const newPath = LEGACY_OPTION_TO_NEW_PATH[option] || "/historiales";
	return <Navigate to={newPath} replace />;
};

export const OAOrRedirect = () => {
	const { user } = useUserStore();
	const location = useLocation();

	if (Number(user?.user_id) === OA_REDIRECT_USER_ID || OA_REDIRECT_CUSTOMER_IDS.includes(Number(user?.customer_id))) {
		return <Navigate to={`/planificacion/ordenes_aplicacion${location.search || ""}`} replace />;
	}

	return <AppOrders />;
};
